<!--
 * @Author: cryi.liu
 * @Date: 2020-06-16 16:03:07
 * @LastEditTime: 2020-06-18 16:16:35
 * @Description: 试题列表
-->
<template>
  <div class="question-list">
    <p class="title">试题列表</p>
    <div class="list-area">
      <p class="category-title">简答题</p>
      <p
        v-for="(question, index) in questionList"
        :key="question.libraryId"
        class="question"
        :class="questionIndex === index ? 'bold' : ''"
        @click="selectQuestionHandler(index)"
        >{{ `${index + 1}、${question.content}` }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'QuestionList',
  props: {
    questionIndex: { type: Number, required: true },
  },
  computed: {
    ...mapGetters({
      questionList: 'answerMarkStore/questionList',
      markUserAtQuestion: 'answerMarkStore/markUserAtQuestion',
    }),
    hasEdit() {
      const tempMarkUser = JSON.parse(JSON.stringify(this.markUserAtQuestion));
      Object.keys(tempMarkUser).forEach((key) => {
        if (tempMarkUser[key] === null) {
          delete tempMarkUser[key];
        }
      });

      return Object.keys(tempMarkUser).length > 0;
    },
  },
  methods: {
    /**
     * 题目选择改变处理函数
     */
    selectQuestionHandler(index) {
      if (this.hasEdit) {
        alert('当前有阅卷未保存，请先保存！');
        return;
      }

      this.$emit('change-question', index);
    },
  },
};
</script>

<style lang="less" scoped>
.question-list {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #f2f2f2;

  > .title {
    background-color: #bbcfe2;
    padding: 2px 0 2px 10px;
    color: #185887;
    font-weight: bold;
  }

  > .list-area {
    width: 100%;
    padding: 6px 10px;
    box-sizing: border-box;

    > .category-title {
      font-weight: bold;
    }

    > .question {
      padding: 4px 0;
      font-size: 10px;
      color: #005aaa;
      text-decoration: underline #005aaa;
      cursor: pointer;

      &.bold {
        font-weight: bold;
      }
    }
  }
}
</style>
